/**
 * The steps in the registration lifecycle.
 * Registration is the same as signup.
 */
export var RegistrationStatus;
(function (RegistrationStatus) {
    /**
     * The user has not requested to sign up themselves, but has been invited into the system
     * (e.g.: via a distributed transcript or added by an admin).
     */
    RegistrationStatus["Preregistered"] = "pre-registered";
    /**
     * The user has requested to sign up (by providing their name and email address).
     * They have not proven ownership of their email address at this stage.
     *
     * Note: The Confirmed status was introduced after the Registered status and users get migrated
     * to it upon accessing the site. Any users who have not accessed the site since the introduction
     * of the Confirmed status may still appear as Registered, even though they should actually be
     * Confirmed.
     */
    RegistrationStatus["Registered"] = "registered";
    /**
     * The user has requested to sign up (by providing their name and email address).
     * They have not proven ownership of their email address at this stage and have not
     * been registered on the authentication provider yet.
     */
    RegistrationStatus["PendingAuthProvider"] = "pending-auth-provider";
    /**
     * The user has registered and proven ownership of their email address,
     * or an E2E test has confirmed the user with a password.
     */
    RegistrationStatus["Confirmed"] = "confirmed";
})(RegistrationStatus || (RegistrationStatus = {}));
